import { ApiSanctionType, ApiScreeningTestCaseScreenableTextTypeEnum } from '../../api';
import { Result } from './ScreeningTestsSandbox';
import React from 'react';
import { Form, Formik, FormikHelpers, FormikProps } from 'formik';
import { Card, Form as ReactForm } from 'react-bootstrap';
import FormField from '../../form/FormField';
import * as Yup from 'yup';
import { screeningTestCaseApi, TestScreeningCaseRequest } from '../../apis';
import { Button, SalvDropdown } from '@salvapp/ui-components';
import { parseErrorMessage } from '../../common/errors/helpers';

const validationSchema = Yup.object().shape({
  screenableText: Yup.string().required('Required').min(3, 'Minimum length is 3'),
});

const screenableTextTypeOptions = Object.entries(ApiScreeningTestCaseScreenableTextTypeEnum).map(([key, value]) => ({
  key: key,
  value: value,
  label: value,
}));

const screeningListTypeOptions = Object.entries(ApiSanctionType).map(([key, value]) => ({
  key: key,
  value: value,
  label: value,
}));

type Values = {
  screeningListType: {
    key: string;
    value: ApiSanctionType;
    label: string;
  };
  screenableTextType: {
    key: string;
    value: ApiScreeningTestCaseScreenableTextTypeEnum;
    label: string;
  };
  screenableText: string;
};

interface Props {
  setResults: (result: Result) => void;
}

const ScreeningTestsSandboxInput = ({ setResults }: Props) => {
  const submit = async (values: Values, { setStatus, setSubmitting }: FormikHelpers<Values>) => {
    try {
      const request = {
        apiScreeningTestCase: {
          screenableText: values.screenableText,
          screenableTextType: values.screenableTextType.value,
          screeningListType: values.screeningListType.value,
        },
      } as TestScreeningCaseRequest;
      const hits = await screeningTestCaseApi.testScreeningCase(request);
      setResults({ hits: hits });
    } catch (e) {
      setStatus(await parseErrorMessage(e));
    }
    setSubmitting(false);
  };

  const initialValues: Values = {
    screenableTextType: screenableTextTypeOptions[0],
    screeningListType: screeningListTypeOptions[0],
    screenableText: '',
  };

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={submit}
      initialValues={initialValues}
    >
      {({ isSubmitting, values, setFieldValue, resetForm }: FormikProps<Values>) => {
        return (
          <Form>
            <Card>
              <Card.Body>
                <div className='w-100 mb-4'>
                  <SalvDropdown
                    label={'Screen as'}
                    options={screenableTextTypeOptions}
                    value={values.screenableTextType}
                    clearable={false}
                    onChange={([option]) => {
                      setFieldValue('screenableTextType', option);
                    }}
                  />
                </div>

                <div className='w-100 mb-4'>
                  <SalvDropdown
                    label={'Screening list type'}
                    options={screeningListTypeOptions.filter(
                      (it) => it.value !== ApiSanctionType.CUSTOM_SCREENING_LIST
                    )}
                    value={values.screeningListType}
                    clearable={false}
                    onChange={([option]) => {
                      setFieldValue('screeningListType', option);
                    }}
                  />
                </div>

                <FormField name='screenableText' label='Input' placeholder='Input' />
              </Card.Body>
              <Card.Footer className='text-end'>
                <ReactForm.Group className='form-group mt-4'>
                  <Button
                    variant='outline-secondary'
                    onClick={() => {
                      resetForm();
                      setResults({ hits: [] });
                    }}
                    className='me-3'
                  >
                    Clear
                  </Button>
                  <Button disabled={isSubmitting} type='submit' variant='primary'>
                    Search
                  </Button>
                </ReactForm.Group>
              </Card.Footer>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ScreeningTestsSandboxInput;
